export default "/SiteCollectionImages/react-apps/nykredit/src/images/_privatsikring_16660.jpg";